export const isPhone = (str: string) =>
  /^((\+|00)?\d{2,3})?[0-9-\s*]{4,15}$/.test(str)
